/**
 * Stable CSS class names for E2E — MobileExpress Fraud page.
 */
export const MEF = {
    page: 'mobile-express-fraud-page',
    breadcrumbSection: 'mobile-express-fraud-page__breadcrumb-section',
    loadingSection: 'mobile-express-fraud-page__loading-section',
    mainLayout: 'mobile-express-fraud-page__main-layout',
    inputSection: 'mobile-express-fraud-page__input-section',
    inputTextOrderNumbers: 'mobile-express-fraud-page-input--text-order-numbers',
    hintText: 'mobile-express-fraud-page__hint-text',
    actionsRow: 'mobile-express-fraud-page__actions-row',
    clearButtonWrap: 'mobile-express-fraud-page__clear-button-wrap',
    inputButtonClear: 'mobile-express-fraud-page-input--button-clear',
    processButtonWrap: 'mobile-express-fraud-page__process-button-wrap',
    inputButtonProcess: 'mobile-express-fraud-page-input--button-process',
    resultsSection: 'mobile-express-fraud-page__results-section',
    resultsCard: 'mobile-express-fraud-page__results-card',
    statGrid: 'mobile-express-fraud-page__stat-grid',
    statItem: 'mobile-express-fraud-page__stat-item',
    unmatchedCard: 'mobile-express-fraud-page__unmatched-card',
    unmatchedListWrap: 'mobile-express-fraud-page__unmatched-list-wrap',
    unmatchedList: 'mobile-express-fraud-page__unmatched-list',
    unmatchedListItem: 'mobile-express-fraud-page__unmatched-list-item',
} as const;
